import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="10"/> <path fill="#fff" d="M11.308 14.071h1.384L13 10.93V7h-2v3.929zM11 17h2v-2h-2z"/>' }
  })
);